"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableData = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
const tailwind_merge_1 = require("tailwind-merge");
function TableData({ children, testId, className, subdued = false, hideOnMobile = false, }) {
    return (react_1.default.createElement("td", { className: (0, tailwind_merge_1.twMerge)('whitespace-nowrap py-5 pl-4 pr-3', hideOnMobile && 'hidden sm:table-cell', className), "data-testid": testId },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('grid', 'font-body', 'font-bodyWeight', 'text-bodySSize', 'leading-bodyS', 'tracking-body', 'cursor-default', 'text-defaultTextColor', subdued && 'text-subduedTextColor') }, children)));
}
exports.TableData = TableData;
//# sourceMappingURL=TableData.js.map